export const cdnUrlBase = "//d2ewqegiup45zc.cloudfront.net";



// WEBPACK FOOTER //
// ./src/constants/config.js